"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findElementRecursive = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "findElementRecursive", { enumerable: true, get: function () { return dom_utilities_1.findElementRecursive; } });
//# sourceMappingURL=findElementRecursive.js.map